import { FC } from 'react';

import { LineChartItem } from './LineChartSimple';
import type { TooltipContentProps } from 'recharts';

type CustomLineChartTooltipProps = Partial<TooltipContentProps<number, string>> & {
  companyName: string;
  yourTeamName: string;
  showCompanyAverage?: boolean;
  formatValue?: (value: number) => string;
  valueSuffix?: string;
};

export const CustomLineChartTooltip: FC<CustomLineChartTooltipProps> = ({
  active,
  payload,
  label,
  companyName,
  yourTeamName,
  showCompanyAverage = true,
  formatValue = (n: number) => String(n),
  valueSuffix = '',
}) => {
  if (!active || !payload?.length) return null;

  const { companyAverage, score } = payload[0].payload as LineChartItem;

  const formatOptionalValue = (value: number | undefined) =>
    value === undefined ? '—' : `${formatValue(value)}${valueSuffix}`;

  return (
    <div className="bg-white outline outline-custom-warm-grey-200 rounded-[12px] shadow-custom-tooltip min-w-[160px]">
      <div className="text-body-12-regular text-custom-warm-grey-700 px-3 py-2 border-b border-b-custom-warm-grey-200 flex items-center justify-between">
        <p>{label}</p>
      </div>
      <div className="flex flex-col gap-2 px-3 py-2 text-custom-warm-grey-700">
        <div className="flex items-center justify-between">
          <p className="text-body-12-regular">{yourTeamName}</p>
          <p className="text-body-12-semibold">{formatOptionalValue(score)}</p>
        </div>
        {showCompanyAverage && (
          <div className="flex items-center justify-between">
            <p className="text-body-12-regular">{companyName}</p>
            <p className="text-body-12-semibold">{formatOptionalValue(companyAverage)}</p>
          </div>
        )}
      </div>
    </div>
  );
};
